const BlankScreen = () => {
  return <div>Blank</div>;
};

export default BlankScreen;
